import React, { useEffect } from "react"
import { CheckCircle, AlertCircle, AlertTriangle } from 'lucide-react';
import moment from 'moment';

import { RouteAdmin } from "../../../routes/RouteAdmin";
import "../../../scss/Admin/index.scss"
import { IS_BETA } from "../../../utils/constants";
import useAuth from "../../../hooks/useAuth";
import { useNavigate, Link } from "react-router-dom";

import MenuAccount from './MenuAccount'
import MenuHeaderLeft from './MenuHeaderLeft';
import AdminBar from './AdminBar'

export default function Basic(props) {

    const { menu } = props
    const { auth } = useAuth()
    const history = useNavigate()

    const organizationName = auth ? auth?.primaryUser?.organizationName : null
    const verifactuCertificadoFechaExpiracionUnix = auth?.primaryUser?.verifactuCertificadoFechaExpiracion;
    const verifactuCertificadoFechaExpiracion = verifactuCertificadoFechaExpiracionUnix ? moment.unix(verifactuCertificadoFechaExpiracionUnix).locale('es').format('D MMM, YYYY') : null;
    const diasParaExpirarVerifactu = verifactuCertificadoFechaExpiracionUnix ? moment.unix(verifactuCertificadoFechaExpiracionUnix).diff(moment(), 'days') : null;
    const colorVerifactu = diasParaExpirarVerifactu !== null
        ? diasParaExpirarVerifactu <= 7
            ? '#f9b1c0ff' // rojo
            : diasParaExpirarVerifactu <= 30
                ? '#ffcc00' // amarillo
                : '#d6d7d8' // gris
        : '#d6d7d8';

    // He reestructurado la lógica de renderizado del logo y los badges
    const renderBadges = () => (
        <>
            {IS_BETA ? (
                <div
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        overflow: "hidden",
                        marginLeft: 8,
                    }}
                >
                    {IS_BETA && (
                        <span
                            style={{
                                background: "#ff1744",
                                color: "white",
                                fontSize: "0.75rem",
                                fontWeight: 700,
                                letterSpacing: 1,
                                textTransform: "uppercase",
                                padding: "1px 10px",
                                borderRight: "1px solid rgba(255,255,255,0.3)",
                                borderRadius: "8px",
                            }}
                        >
                            BETA
                        </span>
                    )}

                    {organizationName && (
                        <span
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                overflow: 'hidden',
                                marginLeft: 8,
                            }}
                        >
                            <span
                                style={{
                                    display: 'inline-block',
                                    height: '18px',
                                    borderLeft: '1px solid #e0e0e0',
                                    margin: '0 8px',
                                    verticalAlign: 'middle',
                                }}
                            />
                            <span
                                title={organizationName}
                                style={{
                                    display: 'inline-block',
                                    padding: '1px 10px',
                                    fontWeight: 700,
                                    letterSpacing: 1,
                                    textTransform: 'uppercase',
                                    cursor: 'pointer',
                                    whiteSpace: 'nowrap', // clau
                                }}
                            >
                                {organizationName}
                            </span>
                        </span>
                    )}
                </div>
            ) : (
                <>
                    {organizationName && (
                        <span
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                overflow: 'hidden',
                                marginLeft: 8,
                            }}
                        >
                            <span
                                style={{
                                    display: 'inline-block',
                                    height: '18px',
                                    borderLeft: '1px solid #e0e0e0',
                                    margin: '0 8px',
                                    verticalAlign: 'middle',
                                }}
                            />
                            <span
                                title={organizationName}
                                style={{
                                    display: 'inline-block',
                                    padding: '1px 10px',
                                    fontWeight: 700,
                                    letterSpacing: 1,
                                    textTransform: 'uppercase',
                                    cursor: 'pointer',
                                    whiteSpace: 'nowrap', // clau
                                }}
                            >
                                {organizationName}
                            </span>
                        </span>
                    )}
                </>
            )}
        </>
    );

    const verifactu = () => {
        if (!verifactuCertificadoFechaExpiracion) return null;
        let IconComponent = CheckCircle;
        let iconColor = '#4caf50'; // verde
        if (diasParaExpirarVerifactu <= 7) {
            IconComponent = AlertTriangle;
            iconColor = '#f44336'; // rojo
        } else if (diasParaExpirarVerifactu <= 30) {
            IconComponent = AlertCircle;
            iconColor = '#ffcc00'; // amarillo
        }
        const handleClick = () => {
            history(RouteAdmin.VERIFACTU_MANAGEMENT.path)
        };
        return (
            <div
                style={{ background: "#fff", padding: "6px 12px", borderRadius: 10, boxShadow: "0 1px 4px rgba(0,0,0,0.08)", fontWeight: "500", cursor: "pointer", userSelect: "none", display: "flex", alignItems: "center", gap: 6, marginRight: 10 }}
                aria-haspopup="true"
                onClick={() => handleClick()}
            >
                <IconComponent size={20} color={iconColor} style={{ marginRight: 8, flexShrink: 0, marginTop: "-10px" }} />
                <span style={{ fontWeight: 700, fontSize: '14px', textTransform: 'uppercase', letterSpacing: 1, cursor: 'pointer' }}>
                    VERIFACTU
                </span>
            </div>
        );
    };

    useEffect(() => {
        const handleScroll = () => {
            const header = document.querySelector('.header');
            if (!header) return;

            if (window.scrollY > 10) {
            header.classList.add('scrolled');
            } else {
            header.classList.remove('scrolled');
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            <AdminBar />
            <section className="background-gradient">
                <header className="header" style={{ position: 'relative', zIndex: 10 }}>
                    {/* Contenedor Izquierdo: Logo y Badges */}
                    <div className="header-left">
                        <div style={{ backgroundColor: 'white', padding: '2px 20px', borderRadius: 10, display: 'flex', alignItems: 'center', boxShadow: "0 1px 4px rgba(0,0,0,0.08)" }}>
                            <a href="#inicio" className="logo"><div className="logo-icon"></div><span className="logo-text">Gmatik</span></a>
                            {renderBadges()}
                        </div>
                    </div>

                    {/* Centrado absoluto respecto al header */}
                    <div
                        style={{
                            position: 'absolute',
                            inset: 0, // Ocupa todo el header, ignora padding
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            pointerEvents: 'none',
                            zIndex: 50,
                        }}
                    >
                        <div style={{ pointerEvents: 'auto' }}>
                            <MenuHeaderLeft menu={menu} />
                        </div>
                    </div>

                    {/* Contenedor Derecho: Navegación y Perfil */}
                    <div className="header-right" style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', flex: 1 }}>
                            {verifactu()}
                            <MenuAccount />
                        </div>
                    </div>
                </header>

                <br />

                <div style={{ maxWidth: 'calc(100vw - 200px)', margin: "auto" }}>
                    {props.children}
                    <div style={{ height: 100 }} />
                </div>
            </section>
        </>
    )
}